import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
class TypeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      formData: {
        id: '',
        name: '',
        p_id: '',
        save_parasut: ''
      },
      loading: false,
      isLoad: true
    }
  }
  componentDidMount() {
    this.getTypeInfo();
  }
  getTypeInfo = async () => {
    const { id } = this.props.match.params;
    try {
      const response = await apiCall('business/operation/type/info/' + id, 'get', null);
      this.setState({ types: response });
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined ? "" : response[key]
      })
      this.setState({ formData: updatedData }, () => { });
      this.setState({ isLoad: false });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  handleChange = (e) => {
    const { id, type, checked, value } = e.target;
    const inputValue = type === 'checkbox' ? checked : value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: inputValue
      }
    }));
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { id } = this.props.match.params;
    const { formData } = this.state;
    const typeFormData = new FormData();
    Object.keys(formData).forEach(key => {
      typeFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/operation/type/update/' + id, 'post', typeFormData);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  handleDeleteFromParasut = async () => {
    const result = await Swal.fire({
      title: 'Ürün/Hizmet bilgisini paraşüt uygulamasından silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/operation/type/delete-from-parasut/' + this.state.formData.id, 'delete');

          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Silindi!',
          'Ürün/Hizmet paraşütten başarıyla silindi.',
          'success'
        );
      } else {
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  }
  render() {
    const { formData, loading } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateTypePermission = userPermissions.includes('view setting service type');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Servis tipi detayı"
              Breadcrumb={[
                { name: "Servis tipleri", navigate: "operation-types" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="card">
                <form onSubmit={this.handleSubmit}>
                  <div className="body">
                    {/*<div className="text-right"><label
                          className="font-weight-bold text-cyan">{this.state.formData.p_id ? 'Paraşüt Ürün/Hizmet ID:' + this.state.formData.p_id : ""}</label>
                      </div>*/}
                    <div className="row clearfix justify-content-center">

                      <div className="col-lg-6 col-md-12">
                        <label htmlFor="name"
                          className="font-weight-bold text-cyan">
                          Servis Tipi Adı
                        </label>
                        <div className="form-group">
                          <input
                            id="name"
                            className="form-control"
                            placeholder="Servis Tipi Adı Giriniz"
                            type="text"
                            value={formData.name || ''}
                            onChange={this.handleChange}
                          />
                        </div>
                        {/*!this.state.formData.p_id ? (
                          <div className="form-group">
                            <div className="fancy-checkbox">
                              <label htmlFor="save_parasut"
                                     className="font-weight-bold text-cyan">

                                <input
                                    id="save_parasut"
                                    type="checkbox"
                                    checked={formData.save_parasut}
                                    onChange={this.handleChange}
                                />
                                <span>Paraşütte Ürün/Hizmet Kaydı Oluştur</span>
                              </label>
                            </div>
                          </div>
                              ): (
                                  <>
                                    <div className="form-group text-center">
                                      <label htmlFor="save_parasut"
                                             className="font-weight-bold text-cyan text-center">
                                        <span>Ürün/Hizmet Paraşütte Kayıtlı</span>
                                      </label>
                                    </div>
                                    <div className="form-group text-center">
                                      <button type="button" onClick={this.handleDeleteFromParasut} className="btn btn-outline-danger btn-sm"><i className="icon-trash"></i> Ürün/Hizmet Paraşütten Sil </button>
                                    </div>
                                  </>
                              )
                          */}
                      </div>
                    </div>

                  </div>
                  <div className="body">
                    <div className="row clearfix justify-content-center">
                      <div className="col-lg-6 col-md-12">
                        {loading ? (
                          <button className="btn btn-outline-primary btn-block"
                            disabled={true}
                            style={{ textAlign: "-webkit-center" }}>
                            Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                              height={'24px'}
                              color="#268bd2"></ReactLoading>
                          </button>
                        ) :
                          <button disabled={!userHasUpdateTypePermission}
                            className="btn btn-outline-primary btn-block"
                            type="submit">
                            Güncelle
                          </button>}

                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(TypeDetail)));
